(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hood-hub"] && !Shopify.designMode) return;
  try {
    
(() => {
  const locations={timberline:{lat:45.3311,lon:-121.7113,resort:'https://timberlinelodge.com/conditions/'},meadows:{lat:45.3317,lon:-121.6656,resort:'https://www.skihood.com/mountain-report'},skibowl:{lat:45.301,lon:-121.773,resort:'https://skibowl.com/winter-condition-and-lift-status/'},government:{lat:45.304,lon:-121.754,resort:'https://tripcheck.com/'}};
  function start(root){
    if(root.dataset.ready)return;root.dataset.ready='true';
    const t=JSON.parse(root.querySelector('[data-hh-text]').textContent);
    const $=s=>root.querySelector(s);
    const node=(tag,text,cls)=>{const n=document.createElement(tag);if(text!==undefined)n.textContent=text;if(cls)n.className=cls;return n;};
    const date=d=>{const value=new Date(d);return Number.isFinite(value.getTime())?new Intl.DateTimeFormat(document.documentElement.lang||'en',{month:'short',day:'numeric',year:'numeric',hour:'numeric',minute:'2-digit',timeZone:'America/Los_Angeles',timeZoneName:'short'}).format(value):t.missing;};
    const valid=n=>typeof n==='number'&&Number.isFinite(n);
    const inflight=new Map();
    async function json(url,ttl=900000){
      const key='hh-v1:'+url;
      try{const c=JSON.parse(sessionStorage.getItem(key));if(c&&Date.now()-c.at>=0&&Date.now()-c.at<ttl)return c.data;}catch{}
      if(inflight.has(url))return inflight.get(url);
      const job=(async()=>{const res=await fetch(url,{signal:AbortSignal.timeout(14000),headers:{Accept:'application/geo+json, application/json'}});if(!res.ok)throw Error('Unavailable');const data=res.status===204?{features:[],metadata:{generated:Date.now()}}:await res.json();try{sessionStorage.setItem(key,JSON.stringify({at:Date.now(),data}));}catch{}return data;})();
      inflight.set(url,job);try{return await job;}finally{inflight.delete(url);}
    }
    let weatherToken=0;
    async function weather(){
      const token=++weatherToken;const p=locations[$('[data-location]').value];const box=$('[data-weather]');const alerts=$('[data-alerts]');
      box.replaceChildren(node('p',t.loading));alerts.replaceChildren();
      $('[data-forecast-link]').href=`https://forecast.weather.gov/MapClick.php?lat=${p.lat}&lon=${p.lon}`;$('[data-resort-link]').href=p.resort;
      const alertJob=(async()=>{try{const a=await json(`https://api.weather.gov/alerts/active?point=${p.lat},${p.lon}`,300000);if(token!==weatherToken)return;if(!Array.isArray(a.features))throw Error();const current=a.features.filter(f=>f.properties&&(!f.properties.expires||Date.parse(f.properties.expires)>Date.now()));alerts.append(node('strong',t.alerts));if(!current.length)alerts.append(node('p',t.no_alerts));for(const f of current.slice(0,5)){const c=node('div',undefined,'hh-alert');c.append(node('strong',f.properties.event),node('p',f.properties.headline||''),node('small',`${t.expires}: ${date(f.properties.expires)}`));alerts.append(c);}}catch{if(token===weatherToken)alerts.replaceChildren(node('p',t.alert_error));}})();
      try{
        const point=await json(`https://api.weather.gov/points/${p.lat},${p.lon}`,86400000);const url=point.properties?.forecast;
        if(!url||new URL(url).origin!=='https://api.weather.gov')throw Error();
        const report=await json(url);if(token!==weatherToken)return;
        const periods=report.properties?.periods?.filter(p=>Date.parse(p.endTime)>Date.now());if(!periods?.length)throw Error();
        const first=periods[0],issued=report.properties.updateTime||report.properties.generatedAt;
        const top=node('div',undefined,'hh-weather-top');const temp=node('div',valid(first.temperature)?`${first.temperature}°${first.temperatureUnit}`:t.missing,'hh-temperature');
        const desc=node('div');desc.append(node('h3',`${first.name} · ${first.shortForecast}`),node('p',first.detailedForecast||''),node('p',`${t.wind}: ${first.windSpeed} ${first.windDirection}`));
        if(valid(first.probabilityOfPrecipitation?.value))desc.append(node('p',`${t.precip}: ${first.probabilityOfPrecipitation.value}%`));
        top.append(temp,desc);box.replaceChildren(top,node('p',`${t.forecast_issued}: ${date(issued)}`,'hh-muted'));
        if(!issued||Date.now()-Date.parse(issued)>36*3600000)box.append(node('p',t.old,'hh-stale'));
        const next=node('div',undefined,'hh-periods');for(const p of periods.slice(1,4)){const card=node('div',undefined,'hh-period');card.append(node('strong',p.name),node('span',`${p.temperature}°${p.temperatureUnit} · ${p.shortForecast}`));next.append(card);}box.append(next);
      }catch{if(token===weatherToken)box.replaceChildren(node('p',t.unavailable));}
      await alertJob;
    }
    async function snow(){
      const boxes=Array.from(root.querySelectorAll('[data-station]'));boxes.forEach(b=>b.replaceChildren(node('p',t.loading)));
      try{
        const data=await json('https://wcc.sc.egov.usda.gov/awdbRestApi/services/v1/data?stationTriplets=651:OR:SNTL,351:OR:SNTL&elements=SNWD,WTEQ&duration=DAILY&beginDate=-7&endDate=0',3600000);if(!Array.isArray(data))throw Error();
        for(const b of boxes){const station=data.find(s=>s.stationTriplet===b.dataset.station);const dl=node('dl',undefined,'hh-measures');let has=false;
          for(const [element,label]of [['SNWD','depth'],['WTEQ','water']]){const series=station?.data?.find(s=>s.stationElement?.elementCode===element);const value=series?.values?.filter(v=>valid(v.value)&&v.value>=0&&/^\d{4}-\d{2}-\d{2}/.test(v.date)).sort((a,b)=>b.date.localeCompare(a.date))[0];const item=node('div');item.append(node('dt',t[label]),node('dd',value?`${value.value}″`:t.missing));if(value){has=true;item.append(node('small',`${t.observed}: ${value.date.slice(0,10)}`));const age=Date.now()-Date.parse(value.date.slice(0,10)+'T00:00:00-08:00');if(age>72*3600000)item.append(node('p',t.old,'hh-stale'));}dl.append(item);}
          b.replaceChildren(has?dl:node('p',t.unavailable));
        }
      }catch{boxes.forEach(b=>b.replaceChildren(node('p',t.unavailable)));}
    }
    let quakeLoaded=false;
    async function quakes(){
      const b=$('[data-quakes]');b.replaceChildren(node('p',t.loading));
      try{
        const since=new Date(Date.now()-30*86400000).toISOString().slice(0,10);const url=`https://earthquake.usgs.gov/fdsnws/event/1/query?format=geojson&latitude=45.3736&longitude=-121.6959&maxradiuskm=50&starttime=${since}&orderby=time&limit=5&eventtype=earthquake`;const data=await json(url,300000);if(!Array.isArray(data.features))throw Error();
        b.replaceChildren();if(!data.features.length)b.append(node('p',t.quake_empty));const list=node('ul');for(const event of data.features){const p=event.properties||{},li=node('li');const a=node('a',`${t.magnitude} ${valid(p.mag)?p.mag:t.missing} · ${p.place||t.missing}`);if(p.url&&new URL(p.url).origin==='https://earthquake.usgs.gov')a.href=p.url;li.append(a,node('p',`${t.event_time}: ${date(p.time)} · ${t.depth_km}: ${valid(event.geometry?.coordinates?.[2])?event.geometry.coordinates[2].toFixed(1):t.missing}`));list.append(li);}b.append(list,node('p',`${t.checked}: ${date(data.metadata?.generated)}`,'hh-muted'));quakeLoaded=true;
      }catch{b.replaceChildren(node('p',t.unavailable));quakeLoaded=false;}
    }
    $('[data-location]').addEventListener('change',weather);
    $('.hh-quakes').addEventListener('toggle',()=>{if($('.hh-quakes').open&&!quakeLoaded)quakes();});
    $('[data-refresh]').addEventListener('click',async()=>{const button=$('[data-refresh]');button.disabled=true;try{try{for(let i=sessionStorage.length-1;i>=0;i--){const k=sessionStorage.key(i);if(k?.startsWith('hh-v1:'))sessionStorage.removeItem(k);}}catch{}await Promise.allSettled([weather(),snow(),$('.hh-quakes').open?quakes():Promise.resolve()]);}finally{button.disabled=false;}});
    weather();snow();
  }
  document.querySelectorAll('[data-hood-hub]').forEach(start);
  document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-hood-hub]').forEach(start));
})();


  } catch(e) { console.error(e); }
})();
})();
